import auth from "@/views/modules/auth/sso/auth-sso.vue";
import guest from "@/middleware/guest";

const sso = [
  {
    path: "/auth",
    name: "auth.sso",
    component: auth,
    meta: {
      middleware: [guest],
    },
  },
  {
    path: "/auth/callback",
    name: "auth.sso.callback",
    component: auth,
    props: (route) => ({ query: route.query }),
    meta: {
      middleware: [guest],
    },
  }
];

export { sso };
